import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Text } from '@conexasaude/conexa-hero'
import { Illustration } from '@/components/HideIllustrationsExternal'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import { DeviceSuccessModalProps } from './types'

const DeviceSuccessModal: FunctionComponent<
  DeviceSuccessModalProps
> = props => {
  const { consultationId } = props

  const { closeModal } = useModalContext()
  const history = useHistory()
  const styles = useStyles()

  const handleConfirm = () => {
    if (consultationId) {
      history.push(`/meus-atendimentos/atendimento/${consultationId}`)

      return
    }

    history.push('/meus-atendimentos')
  }

  return (
    <Modal
      id="DEVICE_SUCCESS"
      onDismiss={closeModal}
      primaryAction={handleConfirm}
      primaryActionLabel="Ir para consultas"
    >
      <div css={styles.illustrationWrapper}>
        <Illustration name="user-phonesignal-ok" width="172px" />
      </div>
      <Text css={styles.caption}>Tudo certo com o aparelho testado</Text>
    </Modal>
  )
}

export { DeviceSuccessModal }
